import React, { useEffect, useRef } from "react";
import "./Home.css";
import { NavLink } from "react-router-dom";
import Typed from "typed.js";

const Home = () => {
  const typedRef = useRef(null);

  useEffect(() => {
    const options = {
      strings: [
        "Areeb Ahmed",
        "a SOC Analyst",
        "a Web Developer",
        "a React Developer",
        "a MERN Developer",
      ],
      typeSpeed: 70,
      backSpeed: 70,
      loop: true,
    };

    const typed = new Typed(typedRef.current, options);
    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <>
      <div className="container home_container">
        <div className="home_innerdiv">
          <div className="left_div">
            <h1 className="animated-text">
              I am <br />
              <span ref={typedRef} className="colorful-span"></span>
            </h1>
            <p className="description-text">
              Hi, I am Areeb Ahmed from Delhi. A SOC Analyst, with a strong
              focus on cybersecurity, threat analysis, and incident response. I
              also have a background in full-stack development using the MERN
              stack (MongoDB, Express.js, React.js, Node.js), which complements
              my technical foundation. Passionate about cybersecurity and
              continuously learning to stay ahead in the evolving threat
              landscape.
            </p>
            <div className="btn_div">
              <NavLink to={"/playlist"} className="modern-btn btn-projects">
                Projects
              </NavLink>
              <NavLink to={"/contact"} className="modern-btn btn-hire">
                Hire Me
              </NavLink>
              <a
                href="/Areeb_MERN_Resume.pdf"
                target="_blank"
                rel="noreferrer"
                className="modern-btn btn-resume"
              >
                View Resume
              </a>
            </div>
          </div>
          <div className="right_div pic-animate">
            <img
              src="pic.jpg"
              alt="my_image"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
